enum ImageTypeNameEnum {
	mainProductPicture = 'Main Product Picture',
	contextProductPicture = 'Context Product Picture',
	functionalProductPicture = 'Functional Product Picture',
	inspirationalProductPicture = 'Inspirational Product Picture',
	/**
	 * Images that shows measurements.
	 *
	 * For instance when applied to a Malm bureau, it will show the entire bureau measurements, as well as the drawers measurements.
	 */
	measurementIllustration = 'Measurement Illustration'
}

export default ImageTypeNameEnum;
